/* eslint-disable @typescript-eslint/no-unused-vars */
import { Component, inject, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Subscription } from 'rxjs/internal/Subscription';
import { RouterModule } from '@angular/router';
import { Observable } from 'rxjs';
import { STORAGE_KEYS } from '../../../../../shared/constants/storage-keys';
import { BaseQuery } from '../../../../../shared/models/base/base-query';
import { Pagination } from '../../../../../shared/models/internal/pagination';
import { SwPartNumber } from '../../../../../shared/models/sw-part-number/sw-part-number';
import { SwPartNumberApiService } from '../../../../services/api/sw-part-number-api.service';
import { CrudOverviewBaseComponent } from '../../../base/crud-overview-base.component';
import { SwPartNumberRecyclingTableComponent } from '../../../tables/sw-part-number/sw-part-number-recycling-table/sw-part-number-recycling-table.component';

@Component({
  selector: 'app-sw-part-number-recycling-overview',
  imports: [SwPartNumberRecyclingTableComponent, RouterModule],
  templateUrl: './sw-part-number-recycling-overview.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './sw-part-number-recycling-overview.component.scss',
})
export class SwPartNumberRecyclingOverviewComponent
  extends CrudOverviewBaseComponent<SwPartNumber>
  implements OnInit, OnDestroy
{
  private readonly swPartNumberApiService = inject(SwPartNumberApiService);

  private readonly pageFetchFn: (page: number, pageSize: number) => Observable<Pagination<SwPartNumber>>;
  private baseQuery: BaseQuery = {} as BaseQuery;
  private swPartNumberServiceSubscription: Subscription | null = null;

  constructor() {
    super(STORAGE_KEYS.NONE);

    this.pageFetchFn = (page, pageSize) => {
      this.baseQuery.page = page;
      this.baseQuery.pageSize = pageSize;
      return this.swPartNumberApiService.getRecycledSwPartNumbers(this.baseQuery);
    };
  }

  public override ngOnInit(): void {
    super.ngOnInit();

    this.fetchPagedData(true, this.pageFetchFn);

    this.swPartNumberServiceSubscription = this.swPartNumberService.swPartNumberChangeSubject.subscribe({
      next: () => this.fetchPagedData(true, this.pageFetchFn),
    });
  }

  public override ngOnDestroy(): void {
    super.ngOnDestroy();

    if (this.swPartNumberServiceSubscription) {
      this.swPartNumberServiceSubscription.unsubscribe();
    }
  }

  public onScrolledToBottom(): void {
    this.fetchPagedData(false, this.pageFetchFn);
  }

  public onSortByFieldChanged(baseQuery: BaseQuery): void {
    this.baseQuery = baseQuery;
    this.fetchPagedData(true, this.pageFetchFn);
  }

  protected override handleNewSelection(id: string): void {
    throw new Error('Method not implemented.');
  }

  protected override getFriendlyItemName(item?: SwPartNumber | undefined): string {
    return item?.number ? item.number : 'SW Part Number';
  }

  protected override configureDetailsView(item: SwPartNumber): void {
    throw new Error('Method not implemented.');
  }
}
